import React from 'react'
import { Heading, Text } from '@primer/react-brand'
import Container from './Container'
import SectionHeader from './landing/SectionHeader'
import DisplayNumeral from './landing/DisplayNumeral'

// The three steps are a real sequence — you choose, it collects, you analyse —
// so they carry numbers. The number is the visual: Hubot Sans condensed, large,
// muted, sitting above the step like a chapter mark.
const STEPS = [
  {
    heading: 'Choose what to track',
    body:
      'Pick the accounts, actors and search terms that matter to your work, or start from a shared ' +
      'actor set — every US politician and candidate, major US media by market, international ' +
      'officials and more. Organise them into lists.',
  },
  {
    heading: 'CivicLens collects',
    body:
      'Posts from the channels and terms you follow are collected daily, with engagement updated over ' +
      'time. Speech in audio and video is transcribed and text inside images is extracted, so the ' +
      'substance of a post is searchable whatever its medium.',
  },
  {
    heading: 'You make sense of it',
    body:
      'Search, filter and sort by any attribute or list. Track stats over time, build shareable ' +
      'dashboards, ask the AI assistant, set alerts — or take the data out through CSV, the API or ' +
      'the MCP server and use your own tools.',
  },
]

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" style={{ padding: '96px 0', background: 'var(--brand-color-canvas-default)' }}>
      <Container>
        <SectionHeader
          eyebrow="How it works"
          heading="You decide what is worth watching. CivicLens does the rest."
          lede="From a feed of what was posted to an understanding of what it means — in three moves."
        />

        <ol
          className="three-up-grid"
          style={{
            listStyle: 'none',
            margin: '56px 0 0',
            padding: 0,
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: '0 40px',
            borderTop: '1px solid var(--brand-color-border-default)',
          }}
        >
          {STEPS.map(({ heading, body }, i) => (
            <li key={heading} style={{ paddingTop: '28px' }}>
              <DisplayNumeral size="chapter" tone="accent">
                {String(i + 1).padStart(2, '0')}
              </DisplayNumeral>
              <Heading as="h3" size="5" weight="semibold" style={{ marginTop: '20px' }}>
                {heading}
              </Heading>
              <Text as="p" size="200" variant="muted" style={{ marginTop: '12px', marginBottom: 0 }}>
                {body}
              </Text>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  )
}

export default HowItWorksSection
